import React, { useState } from 'react'
import { contactChore } from '../../../../../models/graphqlTypes'
import { useTranslation } from '../../../../../common/hooks'
import { Button } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { ContactType } from './patientContacts.types'
import { ContactModal, ContactModalProps } from './ContactModal'
import { ViewPatientContacts } from './ViewPatientContacts'
import { DoctorPatientProfile } from '../../types/doctorPatients.types'

interface PatientContactsProps {
  contacts?: contactChore[] | null
  contactType: ContactType
  patientProfile: DoctorPatientProfile
  refetchPatientProfile: () => void
}

export const PatientContacts: React.FC<
  React.PropsWithChildren<PatientContactsProps>
> = ({ contacts, contactType, patientProfile, refetchPatientProfile }) => {
  const { t } = useTranslation()
  const [contactModal, setContactModal] = useState<{
    isOpen: boolean
    props?: ContactModalProps
  }>({ isOpen: false })

  const openContactModal = () =>
    setContactModal({
      isOpen: true,
      props: {
        title: t(`patients:addContact.${contactType}`),
        contactType,
        contacts,
      },
    })

  return (
    <>
      {contacts && contacts.length > 0 ? (
        <ViewPatientContacts
          contacts={contacts}
          contactType={contactType}
          openContactModal={openContactModal}
        />
      ) : (
        <Button
          size="small"
          color="primary"
          variant="text"
          onClick={openContactModal}
          startIcon={<AddIcon />}
          sx={{
            p: 1,
            textAlign: 'left',
          }}
          fullWidth
        >
          {t(`patients:addContact.${contactType}`)}
        </Button>
      )}
      {contactModal.isOpen && contactModal.props && (
        <ContactModal
          isOpen={contactModal.isOpen}
          props={contactModal.props}
          onClose={() => setContactModal({ isOpen: false })}
          patientProfile={patientProfile}
          refetchPatientProfile={refetchPatientProfile}
        />
      )}
    </>
  )
}
